export const fetchUserDisplayNames = async (accessToken, userIds) => {
  const uniqueIds = [...new Set(userIds.filter(Boolean))];

  const entries = await Promise.all(
    uniqueIds.map(async (id) => {
      try {
        const response = await fetch(
          `https://api.spotify.com/v1/users/${encodeURIComponent(id)}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        if (!response.ok) return [id, id];
        const user = await response.json();
        return [id, user.display_name || id];
      } catch {
        return [id, id];
      }
    })
  );

  return Object.fromEntries(entries);
};

export const enrichSongsWithAddedByName = (songs, displayNames) =>
  songs.map((song) => ({
    ...song,
    addedByName: song.added_by?.id
      ? displayNames[song.added_by.id] || song.added_by.id
      : 'Unknown',
  }));

export const getAddedByLabel = (song) =>
  song.addedByName || song.added_by?.id || 'Unknown';
